import {createSlice} from '@reduxjs/toolkit'

const initialFrequencyState = {
  frequency: null,
  inspectionDetail: null,
  isArrivedInTheScheduleModule: false,
}

export const FrequencySlices = createSlice({
  name: 'frequency',
  initialState: initialFrequencyState,
  reducers: {
    frequency: (state, action) => {
      state.frequency = action.payload.frequency
    },
    inspectionDetail: (state, action) => {
      state.inspectionDetail = action.payload.inspections_detail
    },
    resetInspectionDetail: (state) => {
      state.inspectionDetail = null
    },
    setIsArrivedInTheScheduleModule: (state, action) => {
      state.isArrivedInTheScheduleModule = action.payload
    },
  },
})
